<form [formGroup]="form">
  <div nz-row [nzGutter]="10">
    <div nz-col [nzSpan]="24">
      <beautyapp-input label="{{'calendar.form.name' | translate}}" formControlName="firstname" required></beautyapp-input>
    </div>
    <div nz-col [nzSpan]="24">
      <beautyapp-input label="{{'calendar.form.lastName' | translate}}" formControlName="lastname" required></beautyapp-input>
    </div>
    <div nz-col [nzSpan]="24">
      <beautyapp-input
        label="{{'calendar.form.phoneNumber' | translate}}"
        formControlName="mobilePhone"
        required
      ></beautyapp-input>
    </div>
  </div>
</form>
<div *nzModalFooter>
  <button nz-button nzType="default" (click)="modal.close()">{{'buttons.close' | translate}}</button>
  <button nz-button nzType="primary" (click)="submit()">{{'buttons.save' | translate}}</button>
</div>
